<script>
  import ImpactInvestment from "../Icons/ImpactInvestment.svelte";
  import MissionDriven from "../Icons/MissionDriven.svelte";
  import Nonprofits from "../Icons/Nonprofits.svelte";
  import PolicyGovernment from "../Icons/PolicyGovernment.svelte";

  export let data;
  export let iconHeight;

  const componentLookup = {
    "Nonprofits & institutions": Nonprofits,
    "Impact investment": ImpactInvestment,
    "Mission-driven company": MissionDriven,
    "Policy & government": PolicyGovernment,
  };
</script>

<svelte:component this={componentLookup[data.type]} size={iconHeight} />

<style>
  :global(.minimap-icon-container .icon) {
    z-index: 5;
  }
</style>
